module.exports = __webpack_public_path__ + "static/media/step4.b739cc8b.png";